import { whenRouteChange as fnWhenRouteChange } from '@gradin/vue-utils'
import { capitalCase, kebabCase } from 'change-case'
import fnDebounce from 'debounce'
import { nanoid } from 'nanoid'
import { computed, type ComputedRef, type Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import DateFormatter from './fmt/date'
import NumberFormatter from './fmt/number'
import PhoneFormatter from './fmt/phone'

/**
 * Since unhandled rejection error is quite annoying when developer
 * doesn't need the return value, the promise will NOT be rejected
 * if the function is canceled by default. You need to specify
 * the option rejectOnCancel: true to capture the rejection.
 */
// const debouncedRequest = useDebounceFn(() => 'response', 1000, { rejectOnCancel: true })
export const debounce = fnDebounce

export const fmt = {
  ...DateFormatter,
  ...NumberFormatter,
  ...PhoneFormatter,
  kebabCase,
  titleCase: capitalCase,
  upperCase: (str: string) => str.toUpperCase(),
}

export const randomId = nanoid

export const whenRouteChange = fnWhenRouteChange

export const useCheckboxIndeterminate = <T>(selected: Ref<T[]>, haystack: ComputedRef<T[]>) => {
  const someSelected = computed(() => {
    return selected.value.length > 0 && selected.value.length < haystack.value.length
  })
  const allSelected = computed({
    get: () => selected.value.length === haystack.value.length && haystack.value.length > 0,
    set: (value: boolean) => {
      if (value) {
        selected.value = haystack.value
      } else {
        selected.value = []
      }
    },
  })

  return {
    someSelected,
    allSelected,
  }
}

export const useUpdateRoute = () => {
  const route = useRoute()
  const router = useRouter()
  const updateRoute = (query: object) => router.push({
    query: { ...route.query, ...query, page: undefined },
  })
  return { updateRoute }
}
